module.exports = __webpack_public_path__ + "img/86.d3be61af.png";